module.exports = "/assets/src/components/GWPPopIn/gwp-soldes-01-2025.jpg";